/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Tile_WeightInputs */

const en_ui_thresholds_tile_weight = /** @type {(inputs: Ui_Thresholds_Tile_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight`)
};

const de_ui_thresholds_tile_weight = /** @type {(inputs: Ui_Thresholds_Tile_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht`)
};

/**
* | output |
* | --- |
* | "Weight" |
*
* @param {Ui_Thresholds_Tile_WeightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_tile_weight = /** @type {((inputs?: Ui_Thresholds_Tile_WeightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Tile_WeightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_tile_weight(inputs)
	return de_ui_thresholds_tile_weight(inputs)
});